import { Dialog } from "@headlessui/react";

export default function ProductionInventoryAdjustmentResult({ results, onClose }) {
  const count = (status) => results.filter((item) => item.status === status).length;
  const errors = results.filter((item) => ["failed", "pending"].includes(item.status));
  return <div>
    <Dialog.Title as="h3" className="text-lg font-semibold text-gray-900">Production completed with inventory adjustment errors</Dialog.Title>
    <p className="mt-2 text-sm text-gray-700">Production was saved as Completed. Other ingredient adjustments continued despite these errors.</p>
    <p className="mt-3 rounded bg-gray-50 p-3 text-sm">Adjusted: {count("adjusted")} · Already recorded: {count("already_adjusted")} · Failed: {count("failed")} · In progress: {count("pending")}</p>
    <ul className="mt-4 max-h-80 space-y-3 overflow-y-auto text-sm" aria-label="Ingredient adjustment errors">
      {errors.map((item, index) => <li key={`${item.assembly_item_id}-${index}`} className="rounded border border-red-200 bg-red-50 p-3">
        <p className="font-semibold text-red-800">{item.sku || "Missing BOM PLU"}{item.assembly_item_id ? ` · Assembly item #${item.assembly_item_id}` : ""}</p>
        <p className="mt-1 whitespace-pre-wrap break-words text-red-700">{item.error}</p>
      </li>)}
    </ul>
    <p className="mt-3 text-sm text-gray-600">Review Adjustment History to retry failed items. Successful deductions will not be repeated.</p>
    <button type="button" onClick={onClose} className="mt-4 rounded bg-main-purple px-4 py-2 text-sm font-semibold text-white">OK</button>
  </div>;
}
